<script>
  import uuid from "uuid-v4"

  import Accordion from "../Accordion.svelte"
  import GeneralDatos from "./General_datos.svelte"
  import GeneralDirecciones from "./General_direcciones.svelte"
  import GeneralTelefonos from "./General_telefonos.svelte"
  import GeneralProfesionales from "./General_profesionales.svelte"
  import GeneralCorreos from "./General_correos.svelte"
  import GeneralIndependientes from "./General_independientes.svelte"
  import GeneralCargos from "./General_cargos.svelte"
  import GeneralFamiliares from "./General_familiares.svelte"
  import GeneralVehiculos from "./General_vehiculos.svelte"
  import GeneralLicencia from "./General_licencia.svelte"
  import OpcionalPoliticos from "./Opcional_politicos.svelte"
  import OpcionalFacebook from "./Opcional_facebook.svelte"
  import { BASE_URL } from "../../stores/BASE_URL"
  import { user } from "../../stores/User"
  import { navigate } from "svelte-routing"

  export let documento

  const datosId = uuid()

  const cargarOpcionales = async (ops) => {
    try {
      const response = await fetch(
        `${BASE_URL}persona.php?documento=${documento}&session_key=${$user.session_key}&ops=${ops}`,
      )
      if (!response.ok) throw new Error("No se pudo consultar la información")

      const resp = await response.json()
      if (resp.status == "error") {
        navigate("/", { replace: true })
        return []
      }

      return Array.isArray(resp.data) ? resp.data : []
    } catch (error) {
      console.error(`Error al cargar ${ops}:`, error)
      return []
    }
  }

  const promisePoliticos = cargarOpcionales("otros_politicos")
  const promiseRedesSociales = cargarOpcionales("otros_redes_sociales")

  let load = {
    correos: false,
    direcciones: false,
    profesionales: false,
    telefonos: false,
    independientes: false,
    cargos: false,
    familiares: false,
    vehiculos: false,
    licencia: false,
  }

  const click = (ops) => {
    switch (ops) {
      case "correos":
        load.correos = true
        break
      case "direcciones":
        load.direcciones = true
        break
      case "profesionales":
        load.profesionales = true
        break
      case "telefonos":
        load.telefonos = true
        break
      case "independientes":
        load.independientes = true
        break
      case "cargos":
        load.cargos = true
        break
      case "familiares":
        load.familiares = true
        break
      case "vehiculos":
        load.vehiculos = true
        break
      case "licencia":
        load.licencia = true
        break
      default:
        break
    }
  }
</script>

<div>
  <Accordion title="Datos Generales" idx={datosId} show={true}>
    <GeneralDatos {documento} />
  </Accordion>
  <Accordion
    title="Grados académicos y títulos profesionales"
    idx={uuid()}
    on:click={() => click("profesionales")}
  >
    {#if load.profesionales}
      <GeneralProfesionales {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Direcciones"
    idx={uuid()}
    on:click={() => click("direcciones")}
  >
    {#if load.direcciones}
      <GeneralDirecciones {documento} />
    {/if}
  </Accordion>
  <Accordion title="Correos" idx={uuid()} on:click={() => click("correos")}>
    {#if load.correos}
      <GeneralCorreos {documento} />
    {/if}
  </Accordion>
  <Accordion title="Teléfonos" idx={uuid()} on:click={() => click("telefonos")}>
    {#if load.telefonos}
      <GeneralTelefonos {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Independientes"
    idx={uuid()}
    on:click={() => click("independientes")}
  >
    {#if load.independientes}
      <GeneralIndependientes {documento} />
    {/if}
  </Accordion>
  <Accordion title="Cargos" idx={uuid()} on:click={() => click("cargos")}>
    {#if load.cargos}
      <GeneralCargos {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Familiares"
    idx={uuid()}
    on:click={() => click("familiares")}
  >
    {#if load.familiares}
      <GeneralFamiliares {documento} />
    {/if}
  </Accordion>
  <Accordion title="Vehículos" idx={uuid()} on:click={() => click("vehiculos")}>
    {#if load.vehiculos}
      <GeneralVehiculos {documento} />
    {/if}
  </Accordion>
  <Accordion
    title="Licencia de conducir"
    idx={uuid()}
    on:click={() => click("licencia")}
  >
    {#if load.licencia}
      <GeneralLicencia {documento} />
    {/if}
  </Accordion>
  {#await promisePoliticos then politicos}
    {#if politicos.length > 0}
      <Accordion title="Políticos" idx={uuid()} show={true}>
        <OpcionalPoliticos {politicos} />
      </Accordion>
    {/if}
  {/await}
  {#await promiseRedesSociales then redes_sociales}
    {#if redes_sociales.length > 0}
      <Accordion title="Redes sociales" idx={uuid()} show={true}>
        <OpcionalFacebook {redes_sociales} />
      </Accordion>
    {/if}
  {/await}
</div>
